import React, { useLayoutEffect, useRef, useState } from 'react';
import { AtSign } from 'lucide-react';
import './mentionSuggestions.css';

export const MentionSuggestions = ({ autocomplete, input }) => {
  const list = useRef(null), [maxHeight, setMaxHeight] = useState(264);
  useLayoutEffect(() => {
    const resize = () => {
      const top = input.current?.getBoundingClientRect().top || 0;
      setMaxHeight(Math.max(44, Math.min(264, top - 76)));
    };
    resize(); window.addEventListener('resize', resize); window.visualViewport?.addEventListener('resize', resize);
    return () => { window.removeEventListener('resize', resize); window.visualViewport?.removeEventListener('resize', resize); };
  }, [input]);
  useLayoutEffect(() => {
    const item = list.current?.children[autocomplete.index];
    if (item && list.current) {
      if (item.offsetTop < list.current.scrollTop) list.current.scrollTop = item.offsetTop;
      else if (item.offsetTop + item.offsetHeight > list.current.scrollTop + list.current.clientHeight) list.current.scrollTop = item.offsetTop + item.offsetHeight - list.current.clientHeight;
    }
  }, [autocomplete.index]);
  return <div ref={list} className="chat-mention-suggestions" id="chat-mention-suggestions" data-testid="chat-mention-suggestions" role="listbox" aria-label="Recent chat participants" style={{ maxHeight }}>
    {autocomplete.candidates.map((person, index) => <button type="button" role="option" tabIndex={-1} key={person.id} id={`chat-mention-option-${person.id}`} data-testid={`chat-mention-option-${person.id}`}
      className={`chat-mention-option${person.isAdmin ? ' is-admin' : ''}`} aria-selected={index === autocomplete.index}
      onPointerDown={(event) => event.preventDefault()} onMouseEnter={() => autocomplete.onHover(index)} onClick={() => autocomplete.choose(person)}>
      <AtSign size={17} aria-hidden="true" /><span data-testid={`chat-mention-option-name-${person.id}`}>{person.username}</span>
    </button>)}
  </div>;
};